import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core/styles'

import { ButtonBaseProps } from '@material-ui/core/ButtonBase'

import LinkButtonBase from 'components/LinkButtonBase'

const styles = (theme: Theme) => createStyles({
  root: {
    width: 72,
    height: 64.34,
    overflow: 'hidden',
  },
  button: {
    width: 72,
    height: 72,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 72,
  },
})

interface Props extends ButtonBaseProps {
  classes: WithStyles<typeof styles>['classes']
  to: string
}

const FabButton: React.SFC<Props> = ({ classes, className, ...props }) => (
  <div className={classNames(className, classes.root)}>
    <LinkButtonBase
      className={classes.button}
      {...props}
    />
  </div>
)

export default withStyles(styles)(FabButton)
